import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Space from "./space"
import LogoWhite from "./logo-white"
import Text from "./text"
import Divider from "./divider"
import Link from "./link"
import ButtonFill from "./button-fill"
import ButtonOutline from "./button-outline"

import { onClickAddFriend, onClickLinkToAppStore } from "../utils/hook"

type Props = {
  utmSource: string
  utmMedium: string
  utmCampaign: string
  utmContent: string
}
const FooterNavigation = ({ utmSource, utmMedium, utmCampaign, utmContent }: Props) => (
  <div className="
    bg-cover
    bg-no-repeat
    bg-[center_top_220px]
    bg-[url('/media/raw-assets/footer/bg-footer-sp.png')]
    lg:bg-[center_top_120px]
    lg:bg-[url('/media/raw-assets/footer/bg-footer-pc.png')]
  ">
    <div className="pt-[40px] lg:pt-[48px] flex flex-col lg:flex-row-reverse flex-end gap-[20px] lg:gap-[130px] justify-center items-center lg:items-end">
      <div className="w-[280px] lg:w-[430px]">
        <StaticImage
          src="../images/footer/footer-phone.png"
          alt=""
          placeholder="none"
          width={852}
        />
      </div>
      <div className="w-[280px] lg:w-[360px]">
        <div>
          <StaticImage
            src="../images/footer/footer-title-logo.png"
            alt=""
            placeholder="none"
            width={494}
          />
        </div>
        <div className="mt-[16px]">
          <div className="block lg:hidden">
            <ButtonFill
              onClick={() => {
                onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent })
              }}
              classes="py-3 pl-5 pr-6 w-full flex justify-center"
              roundedSize="full"
              color="green-800"
            >
              <div className="flex items-center">
                <StaticImage
                  src="../images/footer/button-icon-line.png"
                  alt="LINE"
                  placeholder="none"
                  width={20}
                />
                <Text fontSize="sm" color="white" classes="ml-1">
                  LINEではじめる
                </Text>
              </div>
            </ButtonFill>
            <div className="h-[12px]" />
            <ButtonOutline
              onClick={() => onClickLinkToAppStore("onelink", { utmSource, utmMedium, utmCampaign, utmContent })}
              classes="py-3 pl-5 pr-6 w-full flex justify-center"
              roundedSize="full"
              color="black"
            >
              <Text fontSize="sm" classes="ml-1">
                アプリではじめる
              </Text>
            </ButtonOutline>
          </div>
          <div className="hidden lg:block">
            <div className="flex justify-between">
              <div onClick={() => onClickLinkToAppStore("directApple", { utmSource, utmMedium, utmCampaign, utmContent })}>
                <StaticImage
                  src="../images/footer/app-store-apple.png"
                  alt=""
                  placeholder="none"
                  width={152}
                />
              </div>
              <div onClick={() => onClickLinkToAppStore("directGoogle", { utmSource, utmMedium, utmCampaign, utmContent })}>
                <StaticImage
                  src="../images/footer/app-store-google.png"
                  alt=""
                  placeholder="none"
                  width={189}
                />
              </div>
            </div>
            <div className="mt-[16px]">
              <ButtonFill
                onClick={() => {
                  onClickAddFriend({ utmSource, utmMedium, utmCampaign, utmContent })
                }}
                classes="py-4 pl-5 pr-6 w-full flex justify-center"
                roundedSize="full"
                color="green-800"
              >
                <div className="flex items-center">
                  <StaticImage
                    src="../images/footer/button-icon-line.png"
                    alt="LINE"
                    placeholder="none"
                    width={20}
                  />
                  <Text fontSize="sm" color="white" classes="ml-1">
                    今すぐLINEではじめる
                  </Text>
                </div>
              </ButtonFill>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="h-[46px] lg:h-[70px]" />
    <div className="h-[1px] bg-[#ABDEDE] mx-6 lg:mx-0" />
    <div className="h-[46px] lg:h-[70px]" />

    <nav className="grid grid-cols-16 gap-0">
      <div className="col-start-2 col-end-16">
        <div className="flex flex-col lg:flex-row gap-[30px] lg:items-start lg:justify-between">
          <div>
            <LogoWhite />
            <Space sizeY="8" />
            <div className="flex flex-col items-start justify-start space-y-4">
              <Link href="https://entale.jp">
                <Text fontSize="sm" color="white">会社情報</Text>
              </Link>
              <Link href="/document/terms">
                <Text fontSize="sm" color="white">利用規約・プライバシーポリシー</Text>
              </Link>
              <Link href="/document/law">
                <Text fontSize="sm" color="white">特定商取引法に基づく表記</Text>
              </Link>
              <Link href="document/terms#userdata-external-transmission">
                <Text font-size="sm" color="white">利用者情報の外部送信について</Text>
              </Link>
              <Link href="https://paircare.zendesk.com/hc/ja">
                <Text fontSize="sm" color="white">ヘルプ・お問い合わせ</Text>
              </Link>
              <Link href="/document/biz">
                <Text fontSize="sm" color="white">法人の方はこちら</Text>
              </Link>
            </div>
          </div>

          <div className="flex items-center justify-start space-x-6">
            <Link href="https://twitter.com/paircare_jp">
              <StaticImage
                src="../images/footer/icon-x.png"
                alt="ペアケアのTwitterアカウント"
                placeholder="none"
                width={47}
              />
            </Link>
            <Link href="https://www.facebook.com/paircare.jp">
              <StaticImage
                src="../images/footer/icon-facebook.png"
                alt="ペアケアのFacebookアカウント"
                placeholder="none"
                width={47}
              />
            </Link>
            <Link href="https://www.instagram.com/paircare/">
              <StaticImage
                src="../images/footer/icon-instagram.png"
                alt="ペアケアのInstagramアカウント"
                placeholder="none"
                width={47}
              />
            </Link>
          </div>
        </div>

        <div className="h-[32px]" />

        <div className="hidden lg:block">
          <div className="h-[90px]" />
        </div>

        <div className="lg:text-center">
          <Text fontSize="xs" color="white">Copyright 2024 Entale,Inc All rights reserved.</Text>
        </div>

        <div className="block lg:hidden">
          <div className="h-[160px]" />
        </div>

        <div className="h-[16px]" />
      </div>
    </nav>
  </div>
)

export default FooterNavigation
